import "../styles/services.scss";
import React, { MouseEventHandler } from "react";
import { ReactNode } from "react";
import { Link, NavLink, Route, Switch } from "react-router-dom";
import { Education } from "./services/Education";
import { Talking } from "./services/Talking";
import { Video } from "./services/Video";
import { Home } from "./services/Home";
import { Orgnization } from "./infos/orgnization";


export class Service extends React.Component {
    linkHandle: MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.currentTarget.parentElement?.querySelectorAll("a").forEach((item) => { item.classList.remove("choiced") });
        e.currentTarget.className = "choiced";
        return true;
    }
    render(): ReactNode {
        return (
            <section className="headerinfo info bg">
                <nav>
                    <div>
                        <NavLink to={"/views/services/education"} activeClassName="choiced" onClick={this.linkHandle}>教育活动</NavLink>
                        <NavLink to={"/views/services/talking"} activeClassName="choiced" onClick={this.linkHandle}>文博讲座</NavLink>
                        <NavLink to={"/views/services/home"} activeClassName="choiced" onClick={this.linkHandle}>志愿者之家</NavLink>
                        <NavLink to={"/views/services/video"} activeClassName="choiced" onClick={this.linkHandle}>精彩视频</NavLink>
                    </div>
                </nav>
                <div className="article" id="service">
                    <Switch>
                        <Route path={"/views/services/education"} exact component={Education}></Route>
                        <Route path={"/views/services/talking"} exact component={Talking}></Route>
                        <Route path={"/views/services/home"} exact component={Home}></Route>
                        <Route path={"/views/services/video"} exact component={Video}></Route>
                    </Switch>
                </div>
            </section>

        )

    }
}